import { render, staticRenderFns } from "./PhysicalPersonSearch.vue?vue&type=template&id=6624a128&scoped=true"
import script from "./PhysicalPersonSearch.vue?vue&type=script&lang=js"
export * from "./PhysicalPersonSearch.vue?vue&type=script&lang=js"
import style0 from "./PhysicalPersonSearch.vue?vue&type=style&index=0&id=6624a128&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6624a128",
  null
  
)

export default component.exports